/* Probably don't need this now that its in process.env but lets leave it since changing it may break things */
import React from 'react';

export interface iAppConfig {
    basePath: string;
    apiUri: string;
}

export const appConfig = {
    basePath: import.meta.env.VITE_BACKEND_HOST,
    apiUri: import.meta.env.VITE_BACKEND_HOST,
} as iAppConfig;

const ConfigContext = React.createContext(appConfig);

export const ConfigProvider = ({children}) => (
    <ConfigContext.Provider value={appConfig}>
        {children}
    </ConfigContext.Provider>
);

export const useAppConfig = () => {
    const context = React.useContext(ConfigContext);
    if (context === undefined) {
        throw new Error('useCountState must be used within a CountProvider');
    }
    return context;
};
